module.exports = __webpack_public_path__ + "images/lightspeed-icon.3c6753b763e39a4e224885ac817832fd.svg";